<mat-card class="mat-elevation-z8">
  <form [formGroup]="icustomer_register_form">
    <!-- user details -->
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>First name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='first_name'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Last name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='last_name'>
        </div>
      </div>

    </div>
    <div class="row">
      <!-- <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Union <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='union_id'>
            <option *ngFor="let union of unions" [value]="union['id']">{{union['name']}}
            </option>
          </select>
        </div>
      </div> -->
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Gender <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='gender_id'>
            <option *ngFor="let gender of genders" [value]="gender['id']">{{gender['name']}}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Street Address</label>
          <input type="text" class="form-control code_box" formControlName='street'>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Taluk <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='taluk_id'>
            <option *ngFor="let taluk of taluks" [value]="taluk['id']">{{taluk['name']}}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">District <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='district_id'>
            <option *ngFor="let district of districts" [value]="district['id']">{{district['name']}}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">State <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='state_id'>
            <option *ngFor="let state of states" [value]="state['id']">{{state['name']}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Pincode</label>
          <input type="number" class="form-control code_box" formControlName='pincode'>
        </div>
        <div style="font-style: italic; font-size: small; color: red"
          *ngIf="icustomer_register_form.controls.pincode.errors !== null">
          {{ icustomer_register_form.controls.pincode.errors['error']}}
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Mobile <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="number" class="form-control code_box" formControlName='mobile'>
        </div>
        <div style="font-style: italic; font-size: small"
          [ngStyle]="{'color': icustomer_register_form.controls.mobile.valid? 'green': 'red'}"
          *ngIf="icustomer_register_form.controls.mobile.errors !== null">
          {{ icustomer_register_form.controls.mobile.errors['error']}}
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Alternative mobile </label>
          <input type="number" class="form-control code_box" formControlName='alternate_mobile'>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">
            Customer Type
            <i class="material-icons" style="color: red; font-size: 14px;">star</i>
          </label>
          <select class="form-control dropdown_box" formControlName="customer_type_id"
            (change)="onCustomerTypeChange($event.target.value)">
            <option *ngFor="let customer_type of customer_types" [value]="customer_type['id']">
              {{customer_type['name']}}
            </option>
          </select>
        </div>
      </div>
    
      <!-- Conditionally show the Premium Product field -->
      <div class="col" *ngIf="showProductField">
        <div class="form-group">
          <label for="exampleFormControlSelect1">
            Premium Product
            <i class="material-icons" style="color: red; font-size: 14px;">star</i>
          </label>
          <select class="form-control dropdown_box" formControlName="product_id">
            <option *ngFor="let product of products" [value]="product['id']">
              {{product['short_name']}}
            </option>
          </select>
        </div>
      </div>
    
      <!-- Conditionally show the Ex Employee Union Type field -->
      <div class="col" *ngIf="showExEmployeeUnionField">
        <div class="form-group">
          <label for="exampleFormControlSelect1">
            Ex Employee Union Type
            <i class="material-icons" style="color: red; font-size: 14px;">star</i>
          </label>
          <div *ngIf="icustomer_register_form.value['customer_type_id'] == 2">
            <select class="form-control dropdown_box" formControlName="union_for_icustomer_id">
              <option *ngFor="let icustomer_union of icustomer_union_dict['2']" [value]="icustomer_union['id']">
                {{icustomer_union['name']}}
              </option>
            </select>
          </div>
          <div *ngIf="icustomer_register_form.value['customer_type_id'] == 3">
            <select class="form-control dropdown_box" formControlName="union_for_icustomer_id">
              <option *ngFor="let icustomer_union of icustomer_union_dict['3']" [value]="icustomer_union['id']">
                {{icustomer_union['name']}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- test?\ -->
    

    <div class="row">

      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Business <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control dropdown_box" formControlName='business_id'>
            <option *ngFor="let business of business_list" [value]="business['id']">{{business['name']}}
            </option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Aadhar Number</label>
          <input type="number" class="form-control code_box" formControlName='aadhar_number'>
        </div>
        <div style="font-style: italic; font-size: small; color: red"
          *ngIf="icustomer_register_form.controls.aadhar_number.errors !== null">
          {{ icustomer_register_form.controls.aadhar_number.errors['error']}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="exampleFormControlFile1">Icustomer Image</label>
          <input type="file" class="form-control-file" id="exampleFormControlFile1" (change)="toBase64($event)"
            accept="image/*" formControlName='icustomer_image'>
        </div>
      </div>
      <div class="col" *ngIf="image != null">
        <img [src]="image" style="height: 100px;">
      </div>
    </div>
    <!-- <button style="margin-left: 40%;" mat-raised-button color="primary" [disabled]="!icustomer_register_form.valid"
      (click)="registerIcustomer()">{{action}}</button> -->

    <button style="margin-left: 40%;" mat-raised-button color="primary" [disabled]="!icustomer_register_form.valid"
      (click)="registerIcustomer()">{{action}}
    </button>
    <mat-icon *ngIf="register_on_process">
      <mat-spinner [color]="color" diameter="30" [value]="value" style="margin-top: 3px;margin-left: 12px;">
      </mat-spinner>
    </mat-icon>
  </form>
</mat-card>